var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckoutEdit = function SvgCheckoutEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkout-edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h20v20H1z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4483",
    transform: "translate(-826 -571)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "currentColor",
    "data-name": "Rectangle 2452",
    rx: 8,
    transform: "translate(826 571)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checkout-edit_svg__a)",
    "data-name": "Scroll Group 33",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(837 582)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2628"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1f2a3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Group 2621"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.536 18.909h6.721",
    "data-name": "Path 18607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.708 3.638a2.051 2.051 0 0 1 2.849-.278l1.586 1.236a1.968 1.968 0 0 1 .659 2.737c-.031.05-8.729 10.954-8.729 10.954a1.553 1.553 0 0 1-1.2.58l-3.326.042-.75-3.184a1.5 1.5 0 0 1 .289-1.28Z",
    "data-name": "Path 18608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.075 5.652 5.052 3.88",
    "data-name": "Path 18609"
  })))))));
};
export default SvgCheckoutEdit;